<template>
  <div class="home pb-5">
    <img src="../assets/images/exchange_banner.png" class="w-full max-w-[600px] mx-auto" alt="">
    <!-- <img src="../assets/images/arrow.png"  class="shake-element -mt-10 mx-auto md:-mt-16 md:absolute md:right-[15%]" width="35" alt=""> -->
    <!-- <div class="flex items-center justify-center mt-4 col flex-col md:flex-row">
      <img src="../assets/images/btn_1.png"  class="cursor-pointer mb-2 mb:mt-0 max-w-[220px] w-1/2 md:mr-3" @click="getTicket('dailyget', 1)" alt="">
      <img src="../assets/images/btn_2.png" class="cursor-pointer mb-2 w-1/2 max-w-[220px] md:mr-3" alt="" @click="buyTicketModel = true, tickets = 0, error = ''" >
      <img src="../assets/images/btn_3.png" @click="scrollToTarget"  class="cursor-pointer mb-2 max-w-[220px] w-1/2" alt="">
    </div> -->
    <div class="p-4 max-w-[600px] mx-auto">
      <p class="font-bold px-2 text-white text-left">歡迎30人以下製造業與服務業企業主與員工參加「程曦_企業AI數位培訓」課程報名活動，只要您完成「課程報名」即獲i點數，並且揪企業好友一起參加完成「課程報名」，再獲得i點數，獲得點數可參加優惠券兌換活動。邀請您一起兌換各項禮券，共享優惠，享受生活中的小確幸！</p>
      <div class="mt-5 text-4xl font-bold tracking-widest py-2 bg-[#ffe200] rounded-lg border-white border-dotted border-2 text-[#06133d]">-點擊兌換好禮-</div>
      <div class="mt-2 grid grid-cols-2 gap-2" ref="targetElement">
        <div class="bg-white py-5 px-2 box-item relative" v-for="(item, index) in rewardList" :key="index" @click="gotoBox(item)">
          <div v-if="new Date() > new Date(item.ts_end)" class="z-50 bg-[#0c0c0cbf] w-full h-full absolute top-0 left-0 rounded-[10px] flex items-center justify-center">
            <div class="text-center">
              <p class="text-2xl text-red-500 font-bold">兌換結束</p>
            </div>
          </div>
          <div v-else-if="item.limit_qty === item.sell_qty" class="z-50 bg-[#0c0c0cbf] w-full h-full absolute top-0 left-0 rounded-[10px] flex items-center justify-center">
            <div class="text-center">
              <p class="text-white text-sm">看看其他好禮吧!</p>
              <p class="text-2xl text-red-500 font-bold">全數兌換完畢</p>
            </div>
          </div>
          <!-- <span class="rounded-[12px] bg-[#ff8b17] absolute top-1 right-1 text-white p-1 text-xs" v-if="item.type == '5'">總部兌換</span> -->
          <!-- <span class="rounded-[12px] bg-[#40a79e] absolute top-1 right-1 text-white p-1 text-xs" v-if="item.type == '4'">展場兌換</span> -->
          <span class="rounded-[12px] bg-[#40a79e] absolute top-1 right-1 text-white p-1 text-xs" v-if="item.type === '1' || item.type === '2' || item.type === '3'">電子票券</span>
          <div>
            <!-- <img :src="require(`../assets/images/prod_1.jpg`)" class="mx-auto w-3/4 rounded-full object-cover aspect-square mb-2" alt=""> -->
            <img :src="`https://csai.uupon.com/img/prod_${item.id}.jpg`" class="mx-auto w-3/4 rounded-full object-cover aspect-square mb-2" alt="">
            <div>
              <p class="font-bold">{{ getFirstPart(item.rewardsName) }}</p>
              <p class="mb-2 font-bold">{{ getSecondPart(item.rewardsName) }}</p>
            </div>
          </div>
          <div>
            <div class="flex items-center justify-center">
              <img src="../assets/images/point_icon.png" width="30" alt="">
              <p class="font-bold"><span class="mx-1 text-2xl text-[#c27719]">{{ item.exchangePoints }}</span>點</p>
            </div>
            <div class="flex items-end text-xs justify-center">限量<u class="px-1 text-center text-sm">{{ item.limit_qty }}</u>份</div>
            <div class="flex items-end text-xs justify-center">剩餘<u class="px-1 text-center text-sm">{{ item.limit_qty - item.sell_qty }}</u>份</div>
          </div>
        </div>
      </div>
      <div @click="gotoRecord" class="mt-3 bg-[#0b53d3] py-1 text-xl font-bold w-full text-white rounded-full tracking-widest">兌換紀錄</div>
    </div>
    <div @click="showNoticeModel = true" class="bg-[#40a79e] rounded-l-lg p-2 text-white font-bold z-[99] cursor-pointer max-w-14 fixed right-0 bottom-10">
      <p>活</p>
      <p>動</p>
      <p>注</p>
      <p>意</p>
      <p>事</p>
      <p>項</p>
    </div>
    <!-- <img src="../assets/images/btn_side.png" @click="showNoticeModel = true" width="10%" class="z-[99] cursor-pointer max-w-14 fixed right-0 bottom-10" alt=""> -->
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showModel || showDetail || msgModel">
      <div class="modal-content shadow px-5 py-6 text-[#868686]" v-if="showModel">
        <p class="mb-3 font-bold text-xl text-black">您確定以{{boxContent.exchangePoints}}點兌換「{{boxContent.rewardsName}}」嗎?</p>
        <p class="mb-3">獎品內容:{{boxContent.description.split('&&')[0]}}</p>
        <div class="text-center font-bold mb-3"><span class="text-red-500">!</span>注意事項<span class="text-red-500">!</span><br>
          <div v-html="filteredDescription" class="text-left"></div>
        </div>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-1 shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] w-1/3 mr-3 cursor-pointer" @click="showModel = false">返回</button>
          <button v-if="boxContent.type == 4 || boxContent.type == 5" class="rounded-full bg-[#40a79e] shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] py-1 w-fit px-2 cursor-pointer" @click="box()">確定兌換(工作人員專用)</button>
          <button v-else class="rounded-full bg-[#40a79e] shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] py-1 w-1/3 cursor-pointer" @click="box()">確定兌換</button>
        </div>
      </div>
      <div class="modal-content max-h-[85vh] overflow-y-scroll shadow p-5 text-[#868686]" v-if="showDetail">
        <div class="text-center">
          <p class="mb-3 font-bold text-xl text-black">兌換成功</p>
          <img :src="`https://csai.uupon.com/img/prod_${boxContent.id}.jpg`" class="w-1/2 mx-auto rounded-full object-cover aspect-square mb-3" alt="">
          <p class="mb-3 font-bold text-black">{{ boxContent.rewardsName }}</p>
          <button class="rounded-full text-white bg-[#40a79e] shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] py-1 w-1/3 cursor-pointer" @click="gotoRecord()">兌換紀錄</button>
        </div>
        <!-- <div v-if="res.type === '1'">
          <p class="mb-3 font-bold text-xl text-black">{{ boxContent.rewardsName }}</p>
          <div class="flex items-center mb-3">
            <img :src="require(`../assets/images/prod_${boxContent.id}.jpg`)" class="w-1/2 rounded-full object-cover aspect-square mb-3" alt="">
            <p class="w-full text-center text-xl font-bold text-black">{{res.pincode}}</p>
          </div>
          <p class="mb-3">獎品內容:{{ boxContent.description }}</p>
          <div class="text-left text-sm mb-3">
            <p>電子序號使用相關注意事項</p>
            <p>1.本序號不適用部分百貨門市、賣場門市與外送服務，摩斯漢堡保留各門市是否受理本序號的權利，結帳前請提供序號。不適用門市名單：誠品站前店、台大醫院店、微風店、老虎城店、嘉義耐斯店、台北SOGO店、台科大店、宜蘭新月店、天母SOGO店、京站店、台中榮總店、雙和醫院店、板橋火車站店、台北101店、比漾廣場店、南崁特力店、松山機場店、京站二店、西湖服務區店、南投清境店、南科店、松山火車站店、西螺北服務區店、西螺南服務區店、台北車站店、桃機二航管制區店、汐止遠雄店、桃機二航店、台北榮總店、亞東醫院店、南港車站店、台大兒童醫院店、桃捷A9店、桃園醫院店、桃機一航店、石碇服務區店、三創店、左營環球店、台積12P7店、台北捷運爵士廣場店、中研院店、泰安北服務區店、中壢服務區店、仁德服務區店、蘇澳服務區店、高雄台鋁店、遠東SOGO新竹店、台積電18廠店、羅東車站店、湖口服務區店、台中中山醫店、台積電15B廠店、竹南群聯店。</p>
            <p class="pl-2">(1)可合併訂購其他餐點，唯本序號商品可不需付費。</p>
            <p class="pl-2">(2)本序號商品不可合併其他商品優惠。</p>
            <p class="pl-2">(3)本序號不適用於外送服務。</p>
            <p>2.本序號限兌換序號上所載之指定商品，恕無法更換或加價兌換其他商品，口味以店內實際供應為準。</p>
            <p>3.本序號無法兌換現金且無法與其他行銷活動合併使用。</p>
            <p>4.本序號具唯一性，僅限兌換一次，一經兌換即不可重複使用。</p>
            <p>5.消費者務必善盡保管責任，並謹慎使用，若轉讓本序號轉予他人使用，即表示同意本序號所載之注意事項，若本序號因已被使用而造成消費者本人無法兌換，由消費者自行負責，本序號恕不補發。</p>
            <p>6.本序號為無償取得之贈品，具有效使用期限，請於指定日期113年9月30日前兌換完畢，逾期恕無法使用。</p>
            <p>7.若對本序號使用上有任何疑問請洽摩斯客服0800-208-128。服務時間上午06:00至下午09:00。</p>
          </div>
          <button class="rounded-full text-white bg-zinc-400 py-1 shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] w-1/3 cursor-pointer" @click="showDetail = false">返回</button>
        </div> -->
        <!-- <div v-else-if="res.type === '0' || res.type === '2' || res.type === '3' " class="text-center">
          <p class="mb-3 font-bold text-xl text-black">兌換成功</p>
          <img :src="require(`../assets/images/prod_1.jpg`)" class="w-1/2 mx-auto rounded-full object-cover aspect-square mb-3" alt="">
          <p class="mb-3 font-bold text-black">{{ boxContent.rewardsName }}</p>
          <div class="text-center font-bold mb-3" ><span class="text-red-500">!</span>請注意<span class="text-red-500">!</span><br>為了順利收到禮品,確定兌換後請務必填寫並確認寄送資訊。</div>
          <button class="rounded-full text-white bg-[#40a79e] shadow-[1px_3px_2px_0_rgba(0,0,0,0.5)] py-1 w-1/3 cursor-pointer" @click="writeInfo">填寫資料</button>
        </div> -->
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="msgModel">
        <p class="my-3">{{ msgCode === ''? '': `[${msgCode}]` }}{{ msg }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#40a79e]  py-2 w-1/3 cursor-pointer" @click="closeMsgModel()">確認</button>
        </div>
      </div>
    </div>
    <div class="modal z-[101]" :style="{ height: windowHeight }" v-if="showNoticeModel">
      <div class="relative max-w-[900px] h-full flex items-center justify-center">
        <img src="../assets/images/btn_close.png" @click="showNoticeModel = false" class="absolute right-5 top-7 max-w-[50px] cursor-pointer" width="35px" alt="">
        <div class="relative rounded-lg p-5 max-h-[80vh] w-[90%] mx-auto overflow-y-auto bg-white">
          <div class="text-left  text-sm text-[#3c3d3d]">
            <p class="font-bold">凡參加兌換優惠券者，視為同意下列事項及主辦單位活動辦法：</p>
            <br>
            <ul style="list-style: none;" class="leading-6 pl-4">
              <li>1.參加者須加入「程曦_企業AI數位培訓」LINE官方帳號好友並完成「課程報名」獲得i點數，始得參加「程曦_企業AI數位培訓 」優惠券兌換活動（以下簡稱本活動）。</li>
              <li>2.參加者於參加本活動同時，即同意接受本活動各式活動辦法規範，如有違反，程曦資訊整合股份有限公司（以下簡稱本公司）得取消參加資格，並得就因此所產生之損害，向該參加者請求損害賠償。</li>
              <li>3. 本公司保留隨時修正、暫停、終止或解釋本活動之最終權利（包括但不限於更換活動、提前終止或延長活動時間之最終決定權等事項），並以本活動公告為準。</li>
              <li>4. 本活動之活動時間、方式、活動獎項與數量，依本活動相關分享資訊為準，優惠券好禮數量有限，換完為止。</li>
              <li>5. 本活動為電子票券，圖片僅供參考。票券使用方式依店家規範為準。本公司保有修改或變更活動方式及更換活動獎品權利。本活動獎品如遇有缺貨或不可抗力之因素無法提供時，本公司有權以其他等值商品替代。</li>
              <li>6. 參加者不得以任何非法、欺騙、不實、不公平、不適當、或其他技術性作弊方式取得參加或中獎資格，本公司有權檢視各活動參加者之活動參與行為、兌換情形、集點取得來源是否涉嫌異常情形，例如：人為操作、非屬正常消費集點、蓄意偽造、短時間異常多筆參與行為、透過任何電腦程式參與活動、詐欺或以任何其他不正當的方式，進行不實或虛偽之活動參與行為。活動參加者因上述情形所獲得之活動資格及獎額，或有破壞活動之行為，本公司有權取消其活動資格或兌換資格，若致本公司蒙受任何損害，本公司有權向參加者請求損害賠償。如活動進行中發生參與者有違反常理、或涉嫌不法、或以惡意或不正當之方式影響活動等異常狀況者，本公司有權變更本活動規則。</li>
              <li>7. 本活動如有任何因電腦、網路、電話、技術或其他任何不可歸責於本公司之事由，而使系統服務停止、中斷、誤送活動訊息、兌換通知或使參加者所寄出或登錄之資料有遲延、遺失、錯誤、無法辨識或毀損之情況或有其他任何影響參與者權益之情形，本公司不負任何法律責任，參加者亦不得因此異議。</li>
              <li>8. 本公司保有一切修改、變更、暫停及取消本活動的權利而不作事前通知，亦有對本活動之所有事宜作出解釋或裁決及變更活動獎項及辦法之權利，任何變更內容及其他詳細注意事項公佈於本活動網站，並不另行通知。</li>
              <li>9. 凡參加本活動者，即視為已充分瞭解本注意事項中各項條款，且願意完全遵守及同意本活動之各項規定。</li>
              <li>10. 參加者於參加本活動之同時，即視為同意接受本活動之活動方式、活動辦法、注意事項及「程曦_企業AI數位培訓」系列活動之個人資料報名同意書。如有違反前述任一內容之情事，本活動將取消其活動資格。</li>
              <li>11. 本活動未盡事宜，係依中華民國相關法令補充之，如因本活動涉訟，係依台灣台北地方法院為第一審管轄法院。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import axios from 'axios'
import CryptoJS from 'crypto-js'
import axios from 'axios'
import liff from '@line/liff'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      encryptedString: '',
      key: '5334023153340231',
      decryptedWord: null,
      encryptedBase64: '',
      decryptedData: null,
      rewardList: [],
      showModel: false,
      showNoticeModel: false,
      buyTicketModel: false,
      kn: '',
      openId: '',
      actId: '',
      enableAiCoin: 0,
      tickets: 0,
      msgModel: false,
      msg: '',
      msgCode: '',
      error: '',
      boxId: '',
      lastTickets: 0,
      boxContent: {},
      showDetail: false,
      acountId: '',
      act: '',
      res: {
        pincode: '',
        type: ''
      },
      windowHeight: window.innerHeight,
      inf: '',
      profile: {}
    }
  },
  async created () {
    this.profile.userId = localStorage.getItem('userId') || ''
    this.profile.displayName = localStorage.getItem('displayName') || ''
  },
  async mounted () {
    this.getInf()
    window.addEventListener('resize', this.handleResize)
  },
  computed: {
    filteredDescription () {
      return this.extractContent(this.boxContent.description)
    }
  },
  methods: {
    extractContent (description) {
      if (!description) return '' // 防止空值錯誤
      const parts = description.split('&&')
      return parts.length > 1 ? parts[1] : parts[0] // 如果有 `&&`，則取後面的內容，否則保留原內容
    },
    async getInf () {
      await axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/LineInfo?lineid=${this.profile.userId}`
      }).then((response) => {
        this.inf = response.data
        this.decryptData(this.inf)
        if (this.decryptedData) {
          if (this.decryptedData.code === '100' && this.decryptedData.openId !== '') {
            this.openId = this.decryptedData.openId
          } else {
            this.$router.replace({ name: 'bind', query: { source: 'exchange' } })
          }
          this.getList()
        } else {
          // location.href = 'https://franchisee-fair.uupon.com/'
        }
      })
    },
    getFirstPart (rewardsName) {
      if (!rewardsName) return ''
      return rewardsName.split('-')[0]
    },
    getSecondPart (rewardsName) {
      if (!rewardsName) return ''
      return rewardsName.split('-')[1] || ''
    },
    handleResize () {
      this.windowHeight = window.innerHeight
    },
    // 解密
    decryptData (data) {
      try {
        const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
        const encryptedWordArray = CryptoJS.enc.Base64.parse(data)
        // 使用 AES-128-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encryptedWordArray },
          keyWordArray,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        )
        this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      } catch (error) {
        this.decryptedData = null
      }
    },
    // 加密
    encryptData (data) {
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.encryptedBase64 = encryptedBase64
    },
    closeMsgModel () {
      if (this.msgCode !== '') {
        liff.closeWindow()
      } else {
        this.msgModel = false
      }
    },
    gotoBox (item) {
      if (item.limit_qty === item.sell_qty) return
      this.boxContent = item
      this.showModel = true
    },
    box () {
      const data = {
        openId: this.openId,
        rewards_id: this.boxContent.id
      }
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const inf = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.decryptData(inf)
      axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/ExChange?inf=${inf}`
      }).then((response) => {
        if (response.data.code === 0) {
          this.res.type = response.data.type
          this.showDetail = true
          this.showModel = false
        } else {
          this.msg = response.data.msg
          this.showModel = false
          this.msgModel = true
        }
      })
    },
    async getList () {
      // 有帶inf時取得會員投票的紀錄
      await axios({
        method: 'get',
        url: 'https://csaiapi.uupon.com/RewardsList'
      }).then((response) => {
        this.rewardList = response.data
          .filter(v => v.state === '0')
          .sort((a, b) => a.seq - b.seq)
      })
    },
    scrollToTarget () {
      const targetElement = this.$refs.targetElement
      targetElement.scrollIntoView({ behavior: 'smooth' })
    },
    gotoRecord () {
      this.$router.push({ name: 'record' })
    },
    writeInfo () {
      this.$router.push({ name: 'success', query: { exchangeName: this.boxContent.rewardsName, id: this.boxContent.id, type: this.boxContent.type, openId: this.openId, actId: this.actId, source: 'main' } })
      window.sessionStorage.setItem('history', '0')
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  font-family: 'Inter', sans-serif;
}
.home{
  background: #06133d;
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .box-item{
    border-radius: 12px;
    border: dotted 2px #ffe200;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
      max-height: 70vh;
      overflow-y: auto;
    }
  }
}
@media only screen and (min-width: 768px) {
  .home{
    .box-item{
      // background-image: url('../assets/images/box_bg_pc.png') ;
      // background-size: 70%;
    }
  }
}
</style>
